/* Opens Shopify's native consent preferences; the link remains usable without JavaScript. */
document.addEventListener('click', function (event) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  var link = event.target.closest('[data-dose-cookie-preferences]');
  if (!link || !window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
  event.preventDefault();
  window.privacyBanner.showPreferences().catch(function () {
    window.location.assign(link.href);
  });
});
